export const closeWindow = () => {
  if (window.opener) window.opener.focus();
  window.close();
};
